import React from 'react'
import Layout from '../../Layout'
import OrderPreparedPeykContainer from '../../../../Components/OrdersPeykPart/OrderPreparedPeykContainer/OrderPreparedPeykContainer'

const OrdersPrepared = () => {
  return (
    <Layout>
      <OrderPreparedPeykContainer/>
    </Layout>
  )
}

export default OrdersPrepared